<template>
    <div class="box-page">
        <div class="col-12 pl-0 pr-0">
            <div class="col-12 pl-0 pr-0 d-md-flex flex-column">
                <div class="col-12 d-flex pl-0 flex-column flex-md-row">
                    <div class="col-12 pl-2 pr-2 pl-md-3 pr-md-3 bg-white rounded-cus cus-box-shadow mt-3 pb-1">
                        <div class="col-12 mb-2 pt-3 pl-0 pr-0 d-flex flex-wrap flex-column">
                            <iframe v-if="isYoutube(dataDetailTutorial.tutorial_link)" class="embed-responsive-item rounded" height="480"
                                :src="generateEmbed(dataDetailTutorial.tutorial_link)" allowfullscreen></iframe>
                            <div v-else class="d-flex flex-column">
                                <img v-if="!isImage(dataDetailTutorial.tutorial_thumbnail)" class="img-thumbnail"
                                    :style="{ 'max-height': '300px', 'object-fit': 'cover', 'object-position': 'center 10%' }"
                                    :src="dataDetailTutorial.tutorial_thumbnail" :alt="dataDetailTutorial.tutorial_title">
                                <img v-else class="img-thumbnail"
                                    :style="{ 'max-height': '300px', 'object-fit': 'contain'}"
                                    :src="dataDetailTutorial.tutorial_thumbnail" :alt="dataDetailTutorial.tutorial_title">
                            </div>
                            <div class="col-12 pl-0 pr-0 mt-2 mb-2 d-flex flex-column">
                                <div class="col-12 pl-0 pr-0 font-size-14 font-size-md-16">{{ dataDetailTutorial.tutorial_title }}</div>
                                <span class="badge badge-pill p-2 my-2"
                                    :style="{ 'width': '250px', 'background-color': dataDetailTutorial.tutorial_category_color, 'color': fontColorbyBG(dataDetailTutorial.tutorial_category_color) ? '#FFFFFF' : '#000000' }">{{
                                        dataDetailTutorial.tutorial_category_name }}</span>
                                <a v-if="!isYoutube(dataDetailTutorial.tutorial_link)" target="_blank" :href="dataDetailTutorial.tutorial_link"
                                    class="font-size-10 my-2">
                                    <span class="flex justify-content-center align-items-center">
                                        <i class="fas fa-external-link-alt mr-1"></i>Link - 
                                        {{ dataDetailTutorial.tutorial_title }}
                                    </span>
                                </a>
                                <p class="text-justify font-size-11">{{ dataDetailTutorial.tutorial_caption }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
    data() {
        return {}
    },
    methods: {
        gotoPage(val) {
            this.page = val
            if (this.params) {
                this.getDataTutorial({ params: this.params, page: this.page, limit: this.limit })
            } else {
                this.getDataTutorial({ page: this.page, limit: this.limit })
            }
        },
        fontColorbyBG(bgColor) {
            if (bgColor) {
                let color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor;
                let r = parseInt(color.substring(0, 2), 16); // hexToR
                let g = parseInt(color.substring(2, 4), 16); // hexToG
                let b = parseInt(color.substring(4, 6), 16); // hexToB
                return ((r * 0.299) + (g * 0.587) + (b * 0.114)) <= 186;
            }
        },
        generateEmbed(url) {
            if (url.includes('youtube')) {
                if (url) {
                    let video_id = url.split('v=')[1]
                    let ampersandPosition = video_id.indexOf('&')
                    if (ampersandPosition != -1) {
                        video_id = video_id.substring(0, ampersandPosition)
                    }
                    return "https://www.youtube.com/embed/" + video_id
                }
            } else {
                return url
            }
        },
        isYoutube(url) {
            return url.includes('youtube')
        },
        isImage(str){
            return (str.match(/\.(jpeg|jpg|gif|png)$/) != null);
        },
        ...mapActions('tutorialList', ['getDetailTutorial']),
    },
    computed: {
        ...mapState('tutorialList', ['dataDetailTutorial']),
        ...mapState('auth', ['userData']),
        ...mapGetters('auth', ['isAuth']),
    },
    async created() {
        this.$store.dispatch('setPageTitle', 'Detail E-Learning');
        await this.getDetailTutorial({
            id: this.$route.params.id
        }).catch(err => {
            this.alertMessage = err
            this.$refs.modalAlert.modalShow()
        })
    }
};
</script>